import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = () => {
  // Primary Hotel schema — most important for Google hotel searches
  const hotelData = {
    "@context": "https://schema.org",
    "@type": "Hotel",
    "@id": "https://www.vedhomestays.com/#hotel",
    "name": "Ved Homestays",
    "alternateName": ["Ved Homestay Varanasi", "Ved Home Stays", "Ved Homestays Kashi", "वेद होमस्टेज़ वाराणसी"],
    "image": [
      "https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/c8899xpq_reception.jpeg",
      "https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/jrno0k2e_deluxe%20room%201.jpeg",
      "https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/4uztrsar_hall%20updated%20photo.jpg",
      "https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/rli301qp_premium%20room.jpg"
    ],
    "description": "Ved Homestays is the best homestay in Varanasi near Kashi Vishwanath Temple and Ganga Aarti Ghats. Experience authentic Banarasi hospitality with modern amenities. Affordable rooms from ₹1200/night. Live in Banaras like a Banarasi!",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Near Kashi Vishwanath Temple, Ganga Ghat Road",
      "addressLocality": "Varanasi",
      "addressRegion": "Uttar Pradesh",
      "postalCode": "221001",
      "addressCountry": "IN"
    },
    "telephone": "+919984397001",
    "email": "vedhomestays@gmail.com",
    "url": "https://www.vedhomestays.com",
    "priceRange": "₹1200 - ₹2500",
    "currenciesAccepted": "INR",
    "paymentAccepted": "Cash, UPI, Online Payment",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 25.310826,
      "longitude": 83.010605
    },
    "hasMap": "https://www.google.com/maps/search/Ved+Homestay+Varanasi",
    "starRating": {
      "@type": "Rating",
      "ratingValue": "5"
    },
    "numberOfRooms": 4,
    "petsAllowed": false,
    "checkinTime": "11:00",
    "checkoutTime": "10:00",
    "sameAs": [
      "https://www.airbnb.com/rooms/1336896906573888433",
      "https://www.airbnb.com/rooms/1334814202353309615",
      "https://www.makemytrip.com/hotels/ved_homestay_near_kashi_vishwanath-details-varanasi.html",
      "https://www.goibibo.com/hotels/ved-homestay-near-kashi-vishwanath-hotel-in-varanasi-7914010616395978928/"
    ],
    "amenityFeature": [
      { "@type": "LocationFeatureSpecification", "name": "Free WiFi", "value": true },
      { "@type": "LocationFeatureSpecification", "name": "Air Conditioning", "value": true },
      { "@type": "LocationFeatureSpecification", "name": "24/7 Hot Water", "value": true },
      { "@type": "LocationFeatureSpecification", "name": "Room Service", "value": true },
      { "@type": "LocationFeatureSpecification", "name": "Attached Bathroom", "value": true },
      { "@type": "LocationFeatureSpecification", "name": "Tour Arrangements", "value": true },
      { "@type": "LocationFeatureSpecification", "name": "Airport Pickup", "value": true }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": "50",
      "reviewCount": "50"
    },
    "review": [
      {
        "@type": "Review",
        "author": { "@type": "Person", "name": "Rajesh Kumar" },
        "datePublished": "2024-12-15",
        "reviewBody": "Amazing experience! The homestay is perfectly located near the ghats. The hosts made us feel like family.",
        "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
      },
      {
        "@type": "Review",
        "author": { "@type": "Person", "name": "Priya Sharma" },
        "datePublished": "2024-11-20",
        "reviewBody": "Truly lived like a Banarasi! The rooms are clean, comfortable and the hospitality is exceptional.",
        "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
      },
      {
        "@type": "Review",
        "author": { "@type": "Person", "name": "David Wilson" },
        "datePublished": "2024-10-10",
        "reviewBody": "Best place to stay in Varanasi. Close to temples and ghats. Highly recommended for authentic experience.",
        "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
      }
    ],
    "containsPlace": [
      {
        "@type": "HotelRoom",
        "name": "Deluxe Room",
        "description": "Spacious deluxe room with queen bed, AC, WiFi near Kashi Vishwanath Temple. Ideal for families visiting Varanasi.",
        "bed": { "@type": "BedDetails", "typeOfBed": "Queen", "numberOfBeds": 1 },
        "occupancy": { "@type": "QuantitativeValue", "value": 5 },
        "offers": {
          "@type": "Offer",
          "name": "Deluxe Room - Nightly Rate",
          "price": "1500",
          "priceCurrency": "INR",
          "availability": "https://schema.org/InStock",
          "validFrom": "2026-01-01"
        }
      },
      {
        "@type": "HotelRoom",
        "name": "Standard Room",
        "description": "Cozy standard room with queen bed, AC, WiFi. Perfect for couples visiting Varanasi and Kashi Vishwanath.",
        "bed": { "@type": "BedDetails", "typeOfBed": "Queen", "numberOfBeds": 1 },
        "occupancy": { "@type": "QuantitativeValue", "value": 2 },
        "offers": {
          "@type": "Offer",
          "name": "Standard Room - Nightly Rate",
          "price": "1200",
          "priceCurrency": "INR",
          "availability": "https://schema.org/InStock",
          "validFrom": "2026-01-01"
        }
      },
      {
        "@type": "HotelRoom",
        "name": "Ultra-Large Room",
        "description": "Large group room with 6 single beds, AC, WiFi. Perfect for families and groups visiting Varanasi temples and ghats.",
        "bed": { "@type": "BedDetails", "typeOfBed": "Single", "numberOfBeds": 6 },
        "occupancy": { "@type": "QuantitativeValue", "value": 10 },
        "offers": {
          "@type": "Offer",
          "name": "Ultra-Large Room - Nightly Rate",
          "price": "2500",
          "priceCurrency": "INR",
          "availability": "https://schema.org/InStock",
          "validFrom": "2026-01-01"
        }
      }
    ]
  };

  // LodgingBusiness schema — local business signals
  const localBusinessData = {
    "@context": "https://schema.org",
    "@type": "LodgingBusiness",
    "@id": "https://www.vedhomestays.com/#business",
    "name": "Ved Homestays",
    "image": "https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/c8899xpq_reception.jpeg",
    "url": "https://www.vedhomestays.com",
    "telephone": "+919984397001",
    "email": "vedhomestays@gmail.com",
    "description": "Best homestay in Varanasi near Kashi Vishwanath Temple. Book affordable rooms from ₹1200/night with authentic Banarasi hospitality.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Near Kashi Vishwanath Temple, Ganga Ghat Road",
      "addressLocality": "Varanasi",
      "addressRegion": "Uttar Pradesh",
      "postalCode": "221001",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 25.310826,
      "longitude": 83.010605
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      "opens": "00:00",
      "closes": "23:59"
    },
    "priceRange": "₹1200 - ₹2500",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "bestRating": "5",
      "ratingCount": "50",
      "reviewCount": "50"
    },
    "areaServed": {
      "@type": "City",
      "name": "Varanasi",
      "sameAs": "https://en.wikipedia.org/wiki/Varanasi"
    }
  };

  // WebSite schema with SearchAction — for sitelinks search box
  const websiteData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://www.vedhomestays.com/#website",
    "name": "Ved Homestays Varanasi",
    "alternateName": "Ved Homestays - Best Hotel in Varanasi",
    "url": "https://www.vedhomestays.com",
    "description": "Book affordable rooms in Varanasi near Kashi Vishwanath Temple. Homestay experience with authentic Banarasi hospitality.",
    "publisher": {
      "@type": "Organization",
      "name": "Ved Homestays",
      "url": "https://www.vedhomestays.com",
      "logo": {
        "@type": "ImageObject",
        "url": "https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/c8899xpq_reception.jpeg"
      }
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://www.vedhomestays.com/rooms?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  // FAQPage schema — targets "People Also Ask" in Google results
  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Where is Ved Homestays located in Varanasi?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Ved Homestays is located near Kashi Vishwanath Temple on Ganga Ghat Road, Varanasi, Uttar Pradesh 221001. We are just a 5-minute walk from the famous Kashi Vishwanath Temple and Dashashwamedh Ghat where the Ganga Aarti takes place."
        }
      },
      {
        "@type": "Question",
        "name": "What is the room price at Ved Homestays Varanasi?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our room prices are very reasonable and designed to suit every budget — whether you're a solo traveller, a couple, or a large family group visiting Banaras. Every room comes with AC, free WiFi, attached bathroom, and 24/7 hot water. Visit www.vedhomestays.com/rooms to check room availability and current pricing."
        }
      },
      {
        "@type": "Question",
        "name": "Is Ved Homestays near Kashi Vishwanath Temple?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! Ved Homestays is one of the closest accommodations to Kashi Vishwanath Temple — just a 5-minute walk. You can easily visit the temple for morning and evening darshan without any transportation hassle."
        }
      },
      {
        "@type": "Question",
        "name": "How do I book a room at Ved Homestays Varanasi?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can book a room at Ved Homestays by calling +91 9984397001, messaging on WhatsApp at the same number, emailing vedhomestays@gmail.com, or filling out the booking inquiry form on our website at www.vedhomestays.com/contact. We also accept bookings through Airbnb, MakeMyTrip, and Goibibo."
        }
      },
      {
        "@type": "Question",
        "name": "What are the check-in and check-out times at Ved Homestays?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Check-in time at Ved Homestays is 11:00 AM and check-out time is 10:00 AM. We offer 24/7 check-in assistance, so even if you arrive late at night, we will be there to welcome you."
        }
      },
      {
        "@type": "Question",
        "name": "Does Ved Homestays offer rooms for large groups visiting Varanasi?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! Our Ultra-Large Room can accommodate up to 10 guests with 6 single beds at very reasonable rates. Extra mattresses are also available. It's perfect for families, friend groups, and pilgrim groups visiting Kashi Vishwanath Temple and Varanasi ghats. Visit www.vedhomestays.com/rooms for details and availability."
        }
      },
      {
        "@type": "Question",
        "name": "Is Ganga Aarti viewable from Ved Homestays?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "While Ganga Aarti is not directly visible from the homestay, Dashashwamedh Ghat where the famous Ganga Aarti takes place is just a 5-minute walk from Ved Homestays. You can easily walk to the ghats every evening to witness this spectacular ceremony."
        }
      },
      {
        "@type": "Question",
        "name": "What amenities are available at Ved Homestays Varanasi?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "All rooms at Ved Homestays include Air Conditioning, free high-speed WiFi, attached bathroom with 24/7 hot water, room service, clean linens, and comfortable beds. We also offer tour arrangements for Varanasi sightseeing, airport/station pickup, and local food recommendations."
        }
      },
      {
        "@type": "Question",
        "name": "Why choose Ved Homestays over a hotel in Varanasi?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "At Ved Homestays, you don't just get a room — you experience Banaras like a local. Wake up to temple bells, stroll through ancient galis to the ghats for morning aarti, get insider tips on the best street food from lassi to chaat, and feel the warmth of a Banarasi family welcoming you home. With 5-star Google ratings, a prime location steps from Kashi Vishwanath Temple, and all modern amenities, we deliver authentic local living that no hotel can match."
        }
      },
      {
        "@type": "Question",
        "name": "How far is Ved Homestays from Varanasi Railway Station and Airport?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Ved Homestays is approximately 6 km from Varanasi Junction (Varanasi Cantt) Railway Station (about 20 minutes by auto/cab) and about 30 km from Lal Bahadur Shastri International Airport (about 45-60 minutes by cab). We can arrange airport and station pickup for our guests."
        }
      }
    ]
  };

  // TouristAttraction nearby — helps with "things to do near" searches
  const nearbyAttractionsData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Tourist Attractions Near Ved Homestays Varanasi",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "item": {
          "@type": "TouristAttraction",
          "name": "Kashi Vishwanath Temple",
          "description": "One of the most famous Hindu temples dedicated to Lord Shiva, located in the heart of Varanasi. Just 5 minutes walk from Ved Homestays.",
          "address": { "@type": "PostalAddress", "addressLocality": "Varanasi", "addressCountry": "IN" }
        }
      },
      {
        "@type": "ListItem",
        "position": 2,
        "item": {
          "@type": "TouristAttraction",
          "name": "Dashashwamedh Ghat",
          "description": "The main ghat in Varanasi famous for the spectacular Ganga Aarti ceremony every evening. 5 minutes from Ved Homestays.",
          "address": { "@type": "PostalAddress", "addressLocality": "Varanasi", "addressCountry": "IN" }
        }
      },
      {
        "@type": "ListItem",
        "position": 3,
        "item": {
          "@type": "TouristAttraction",
          "name": "Manikarnika Ghat",
          "description": "One of the most sacred cremation ghats along the Ganges in Varanasi.",
          "address": { "@type": "PostalAddress", "addressLocality": "Varanasi", "addressCountry": "IN" }
        }
      },
      {
        "@type": "ListItem",
        "position": 4,
        "item": {
          "@type": "TouristAttraction",
          "name": "Assi Ghat",
          "description": "Popular ghat at the confluence of Assi River and Ganges, known for morning yoga and cultural activities.",
          "address": { "@type": "PostalAddress", "addressLocality": "Varanasi", "addressCountry": "IN" }
        }
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(hotelData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(nearbyAttractionsData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
